export default "__VITE_ASSET__3a46bf44__"